import { createSlice } from '@reduxjs/toolkit';

import {
  getCarHouseAdmins,
  addCarHouseAdmin,
  editCarHouseAdmin,
  removeCarHouseAdmin,
} from '../actions/carHouseAdmin-actions';

const initialState = {
  isLoading: false,
  carHouseAdmins: [],
};

const carHouseAdminSlice = createSlice({
  name: 'carHouseAdmin',
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getCarHouseAdmins.pending, (state, action) => {
   
        state.isLoading = true;
      })
      .addCase(getCarHouseAdmins.fulfilled, (state, action) => {
        const data = action.payload;

        state.carHouseAdmins = data;
        state.isLoading = false;
      })
      .addCase(getCarHouseAdmins.rejected, (state, action) => {
       // state.isLoading = false;
      })
      .addCase(addCarHouseAdmin.fulfilled, (state, action) => {
        const newAdmin = action.payload;

        state.carHouseAdmins.unshift(newAdmin);

        state.carHouseAdmins = state.carHouseAdmins.sort((a, b) => {
          return a.position - b.position;
        });
      })
      .addCase(removeCarHouseAdmin.fulfilled, (state, action) => {
        const adminId = action.payload;

        state.carHouseAdmins = state.carHouseAdmins.filter(
          (admin) => admin.id !== adminId
        );
      })
      .addCase(editCarHouseAdmin.fulfilled, (state, action) => {
        const editAdmin = action.payload;
        const index = state.carHouseAdmins.findIndex(
          (admin) => admin.id === editAdmin.id
        );
        if (~index) {
          state.carHouseAdmins[index] = editAdmin;
        }
      });
  },
});

export const carHouseAdminActions = carHouseAdminSlice.actions;

export default carHouseAdminSlice;
